import { useEffect, useCallback } from 'react';
import { useMap, useMapEvents } from 'react-leaflet';
import { toast } from 'sonner';

// Track map bounds changes
export const MapBoundsTracker = ({ onBoundsChange }) => {
  const map = useMapEvents({
    moveend: () => onBoundsChange(map.getBounds()),
    zoomend: () => onBoundsChange(map.getBounds())
  });
  useEffect(() => { onBoundsChange(map.getBounds()); }, [map, onBoundsChange]);
  return null;
};

// Fly to location when coords change
export const FlyToLocation = ({ coords, trigger }) => {
  const map = useMap();
  useEffect(() => {
    if (coords && trigger) {
      map.flyTo(coords, 12, { duration: 1 });
    }
  }, [coords, trigger, map]);
  return null;
};

// User location button hook and logic
export const useUserLocation = (setFlyToCoords, setFlyTrigger) => {
  const locateUser = useCallback(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setFlyToCoords([latitude, longitude]);
          setFlyTrigger(prev => prev + 1);
          toast.success('Located you!');
        },
        () => {
          toast.error('Could not get your location');
        },
        { timeout: 5000, enableHighAccuracy: true }
      );
    } else {
      toast.error('Geolocation not supported');
    }
  }, [setFlyToCoords, setFlyTrigger]);

  return { locateUser };
};

export default { MapBoundsTracker, FlyToLocation, useUserLocation };
